<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_contractNo') || '合同号'"
            prop="contractNo"
          >
            <el-input
              v-model.trim="formData.contractNo"
              clearable
              :placeholder="
                $l('INDEX.form_placeholder_contractNo') || '请输入合同号'
              "
              :disabled="formDisabled"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('INDEX.form_bookingType') || '订舱类型'">
            <el-select
              v-model="formData.bookingType"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              style="width: 100%"
            >
              <el-option
                :label="$l('INDEX.form_bookingType_A') || '整箱'"
                value="A"
              ></el-option>
              <el-option
                :label="$l('INDEX.form_bookingType_B') || '拼箱'"
                value="B"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_shipmentType') || '发运方式'"
            prop="shipmentType"
          >
            <dict-select
              url="/master/common/dict/biz"
              v-model="formData.shipmentType"
              :body="shipmentTypeParams"
              :placeholder="
                $l('INDEX.form_placeholder_shipmentTypes') || '请选择发运方式'
              "
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_quotedMethod') || '报价方式'"
            prop="quotedMethod"
          >
            <dict-select
              clearable
              filterable
              size="mini"
              v-model="formData.quotedMethod"
              :body="quotedMethodParams"
              :placeholder="
                $l('INDEX.sample_tips_select_quotation_method') ||
                  '请选择报价方式'
              "
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'
            "
            prop="dispatchPort"
          >
            <dict-select
              filterable
              v-model="formData.dispatchPort"
              url="/master/port/select"
              size="mini"
              clearable
              :placeholder="
                $l('INDEX.form_placeholder_dispatchPort') || '请选择发运港口'
              "
              @change="portChange()"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_destinationPort') || '目的港口'
            "
          >
            <el-select
              v-model="formData.destinationPort"
              :placeholder="
                $l('INDEX.placeholder_destinationPort') || '请选择目的港口'
              "
              filterable
              size="mini"
              clearable
              @change="destinationPortChange"
              style="width: 100%;"
            >
              <el-option
                v-for="item in portData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_destinationPortFullName') || '指运港'"
          >
            <dict-select
              v-model="formData.destinationPortFullName"
              :placeholder="
                $l('INDEX.form_placeholder_destinationPortFullName') ||
                  '请选择指运港'
              "
              url="/master/port/fullNameSelect"
              size="mini"
              clearable
              filterable
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_destinationCountry') || '目的国'"
            prop="destinationCountry"
          >
            <dict-select
              v-model="formData.destinationCountry"
              :placeholder="
                $l('INDEX.form_placeholder_destinationCountry') ||
                  '请选择目的国'
              "
              url="/master/port/countrySelect"
              size="mini"
              clearable
              filterable
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
    <booking-table
      ref="table"
      :tableData="tableData"
      :loading="loading"
      @radioChange="radioChange"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import BookingTable from './table'
import { request } from '@/api/service'
export default {
  components: { BookingTable },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {
        bookingType: 'A',
        dispatchPort: '',
        destinationPort: '',
        destinationPortFullName: '',
        destinationCountry: '',
      },
      rules: {
        dispatchPort: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_dispatchPort') ||
              '请选择发运港口',
            trigger: 'change',
          },
        ],
        contractNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_contractNo') || '请输入合同号',
            trigger: 'blur',
          },
        ],
        shipmentType: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_shipmentTypes') ||
              '请选择发运方式',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message:
              this.$l('INDEX.sample_tips_select_quotation_method') ||
              '请选择报价方式',
            trigger: 'change',
          },
        ],
      },
      tableData: [],
      loading: false,
      formDisabled: false,
      shipmentTypeParams: { dictType: 'shipmentType' },
      quotedMethodParams: { dictType: 'quotedMethod' },
      portData: [],
    }
  },
  computed: {
    listBox() {
      return this.data.listBox
    },
  },
  async mounted() {
    await this.selectPort()
    this.initPort() //获取港口数据
    this.portChange()
    this.getBookingType() //选择订舱类型
  },
  methods: {
    getData() {
      this.loading = true
      if (!this.shipmentCode) return
      this.$api
        .shipmentBookingListByPortApi({
          shipmentCode: this.shipmentCode,
          dispatchPort: this.formData.dispatchPort,
          destinationPort: this.formData.destinationPort,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    initPort() {
      if (!this.listBox || !this.listBox.length) {
        return
      }

      const firstDispatchPort = this.listBox[0].dispatchPort
      const firstDestinationPort = this.listBox[0].destinationPort

      let result = this.listBox.every(
        ({ dispatchPort }) => dispatchPort === firstDispatchPort
      )
      if (result) {
        this.formData.dispatchPort = firstDispatchPort
      }

      result = this.listBox.every(
        ({ destinationPort }) => destinationPort === firstDestinationPort
      )
      if (result) {
        this.formData.destinationPort = firstDestinationPort
        this.destinationPortChange(firstDestinationPort)
      }
    },
    portChange() {
      const { dispatchPort } = this.formData
      if (dispatchPort) {
        this.getData()
      } else {
        this.tableData = []
      }
      this.radioChange(null)
    },
    //根据箱型选择订舱类型
    getBookingType() {
      const containerName = this.data.containerName
      if (containerName === 'LCL') {
        //箱型为LCL，默认订舱类型为拼箱
        this.formData.bookingType = 'B'
      } else {
        this.formData.bookingType = 'A'
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      this.$api
        .shipmentContainerAddContainerAndBookingApi({
          ...this.formData,
          ...this.data,
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(res.msg)
            return
          }
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async append() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)

      const radioData = this.$refs.table.getRadioRecord()
      if (!radioData) return
      const shipmentBookingCode = radioData.shipmentBookingCode

      this.loadingOpen()
      this.$api
        .shipmentContainerAddContainerAndBookingApi({
          ...this.formData,
          ...this.data,
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: shipmentBookingCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(res.msg)
            return
          }
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    radioChange(data) {
      if (data) {
        this.formDisabled = true
        this.rules.contractNo[0].required = false
        this.rules.shipmentType[0].required = false
        this.rules.quotedMethod[0].required = false
      } else {
        this.formDisabled = false
        this.rules.contractNo[0].required = true
        this.rules.shipmentType[0].required = true
        this.rules.quotedMethod[0].required = true
      }
      this.$emit('radioChange', data)
    },
    async selectPort() {
      const res = await request({
        url: '/master/port/select',
        method: 'POST',
      }).catch(() => null)
      if (!res) return
      this.portData = res.body.data
    },
    destinationPortChange(e) {
      this.portChange()
      const data = this.portData.filter((item) => item.value === e)[0]
      if (!data) return
      const { portCountry, portFullName } = data
      this.formData.destinationPortFullName = portFullName || ''
      this.formData.destinationCountry = portCountry || ''
    },
  },
}
</script>
